export const IMASK_PATTERNS = {
  CNPJ: 'aa.aaa.aaa/aaaa-00',
  CNAE: '0000-0/00',
  CPF: '000.000.000-00',
  CEP: '00000-000',
  PHONE: '(00) 00000-0000',
  BIRTHDATE: '00/00/0000',
  BANK_BRANCH: '0000'
};

export const IMASK_DEFINITIONS = {
  CNPJ: {
    a: /[a-zA-Z0-9]/
  }
};
